import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CancellationPolicyModal } from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfo/CancellationPolicyModal';
import Loading from 'venuescanner-js/react/components/Inbox/components/Objects/Loading';
import IconCreditCards from 'venuescanner-js/react/components/Objects/Icons/IconCreditCards';
import IconShield from 'venuescanner-js/react/components/Objects/Icons/IconShield';
import IconWallet from 'venuescanner-js/react/components/Objects/Icons/IconWallet';
import countries from 'venuescanner-js/constants/countries.json';
import './PaymentSummary.scss';
import { getTotal } from '../../../../helpers/quote';

const BookingsCovered = ({ venue }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onCancellationPolicyClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const cancellationPolicy = venue.cancellation_policy;

  return (
    <>
      <div className='bookings-covered'>
        <CancellationPolicyModal
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          cancellationPolicy={cancellationPolicy}
        />
        <div className='bookings-covered__icon'>
          <IconShield aria-hidden='true' focusable='false' />
        </div>
        <div className='bookings-covered__text'>
          <p>
            Bookings are covered by the venue's{' '}
            <Link to='#' onClick={onCancellationPolicyClick}>
              cancellation policy
            </Link>{' '}
            and VenueScanner's{' '}
            <Link
              to='/terms-and-conditions'
              rel='noreferrer noopener'
              target='_blank'>
              terms and conditions
              <span className='visually-hidden'>(opens in new tab)</span>
            </Link>
            .
          </p>
        </div>
      </div>
    </>
  );
};

const PayNowButton = ({ onClick, isLoading }) => {
  return (
    <button onClick={onClick} className='pay-now-button' disabled={isLoading}>
      {isLoading ? <Loading /> : 'Pay now'}
    </button>
  );
};

const AcceptedPaymentsMethods = ({}) => {
  return (
    <>
      <div className='accepted-payments-methods'>
        <div className='accepted-payments-methods__text'>
          <span>Accepted payment methods</span>
        </div>
        <div className='accepted-payments-methods__icon'>
          <IconCreditCards aria-hidden='true' focusable='false' />
        </div>
      </div>
    </>
  );
};

const PaymentToConfirm = ({ price }) => {
  return (
    <>
      <div className='payment-to-confirm'>
        <div className='payment-to-confirm__text'>
          <span>Payment to confirm booking</span>
        </div>
        <div className='payment-to-confirm__price'>
          <span>{`£${price}`}</span>
        </div>
      </div>
    </>
  );
};

const RemaniningBalance = ({}) => {
  return (
    <>
      <div className='remaining-balance'>
        <div className='remaining-balance__text'>
          <span>
            The host will let you know the date the remaining balance is due.
          </span>
        </div>
        <div className='remaining-balance__icon'>
          <IconWallet aria-hidden='true' focusable='false' />
        </div>
      </div>
    </>
  );
};

const EventPrice = ({ concept, thread, price }) => {
  const amount = price || thread.cumulativeOffer.cost;

  return (
    <div className='event-price'>
      <div className='event-price__text'>
        <span>{concept}</span>
      </div>
      <div className='event-price__price'>
        <span>{`£${amount}`}</span>
      </div>
    </div>
  );
};

const Line = ({ variant }) => {
  return (
    <div>
      <hr className={`payment-summary__line_${variant}`} />
    </div>
  );
};

const EventTitle = ({ space, thread }) => {
  const { name, url: spaceUrl } = space.data();

  return (
    <div className='event-title'>
      {thread.event_type && (
        <div className='event-title__type'>
          <span>{thread.event_type} at</span>
        </div>
      )}
      <Link target='_blank' to={spaceUrl}>
        <div className='event-title__location'>
          <span>{`${name}`}</span>
        </div>
      </Link>
    </div>
  );
};

export const PaymentSummary = ({
  thread,
  venue,
  onClick,
  space,
  isLoading,
}) => {
  const activeCurrency = countries[venue.country_code || 'GB'];
  const { cumulativeOffer } = thread;
  const totalPrice = getTotal(cumulativeOffer, activeCurrency?.currency.code);

  const hasDeposit =
    thread.depositAmountValue > 0 && thread.depositAmountValue < thread.price;

  return (
    <div className='payment-summary'>
      <EventTitle thread={thread} space={space} />
      <EventPrice concept='Event Price' price={totalPrice} />
      {hasDeposit && (
        <>
          <Line variant={'gray'} />
          <EventPrice
            concept='Deposit'
            price={cumulativeOffer.first_deposit_amount}
          />
        </>
      )}
      <Line variant={'black'} />

      {cumulativeOffer.first_deposit_amount > 0 &&
        cumulativeOffer.first_deposit_amount !==
          parseFloat(cumulativeOffer.cost) && (
          <>
            <PaymentToConfirm price={cumulativeOffer.first_deposit_amount} />
            <RemaniningBalance />
          </>
        )}

      <BookingsCovered venue={venue} />
      <PayNowButton onClick={onClick} isLoading={isLoading} />
      <AcceptedPaymentsMethods />
    </div>
  );
};
